import {AboutCover ,HomeSectionFive, Presentation , AboutSectionII, Comment, Principes } from '../components'



const About = () => {
  return (
    <div>
        <AboutCover/>
        <Presentation/>
        <AboutSectionII/>
        <Comment/>
        <Principes/>
       <HomeSectionFive/>
    </div>
  )
}

export default About
